<div *ngIf="editMode" style="margin-right: 40px">
  <p-skeleton height="32px" [width]="minWidth" styleClass="skeleton-with-border" *ngIf="!utilisateursLoaded"></p-skeleton>
  <p-dropdown
    scrollHeight="400px"
    inputId="utilisateursDropdown{{ guid }}"
    name="utilisateursDropdown{{ guid }}"
    [options]="utilisateurs"
    [(ngModel)]="utilisateur"
    [required]="required"
    [disabled]="disabled"
    dataKey="Id"
    [showClear]="showClear"
    [resetFilterOnHide]="true"
    appendTo="body"
    [placeholder]="placeholder"
    emptyMessage="Aucun résultat trouvé"
    filter="true"
    [filterFields]="['Nom', 'Prenom', 'Email']"
    [emptyFilterMessage]="'Aucun résultat'"
    [virtualScroll]="true"
    [virtualScrollItemSize]="38"
    [panelStyle]="panelStyle"
    [autoDisplayFirst]="false"
    [style]="pDropdownStyle"
    #utilisateurCtrl="ngModel"
    (ngModelChange)="utilisateurChanged()"
    *ngIf="utilisateursLoaded"
    styleClass="no-ellipsis"
  >
    <ng-template let-item pTemplate="selectedItem">
      <span *ngIf="item"
        >{{ item.Nom }} {{ item.Prenom }} <span *ngIf="item.Email">({{ item.Email }})</span></span
      >
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="ui-helper-clearfix">
        <span>{{ item.Nom }} {{ item.Prenom }} ({{ item.Email }})</span>
      </div>
    </ng-template>
  </p-dropdown>
  <button type="button" class="btn btn-link btn-sm btn-link-primary" [ngClass]="showAll ? 'showAll' : 'notShowAll'" (click)="toggleShowAll()" title="Voir les utilisateurs de l'établissement / Tous'" style="position: absolute; top: 2px"
    ><i class="fa fa-users" aria-hidden="true"></i
  ></button>
</div>
<ng-container *ngIf="_utilisateur && !editMode">
  <span>{{ _utilisateur.Nom }} {{ _utilisateur.Prenom }} ({{ _utilisateur.Email }})</span>
</ng-container>
